import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

const icons = {
    ReceiptLongIcon
};

const insurerBillingTable = {
    id: 'insurer_billing',
    type: 'group',
    children: [
        {
            id: 'insurer_billing_table',
            title: 'Insurer Billing',
            type: 'item',
            url: '/insurer_billing',
            icon: icons.ReceiptLongIcon,
        }
    ]
};

export default insurerBillingTable;